import React, { useEffect, useState } from "react"
import axios from "axios"
import { useParams } from "react-router-dom"
import moment from "moment/moment"
import { Container, Row, Input, FormGroup } from "reactstrap"
import Absent from "../Report/Absent"
import { useDispatch } from "react-redux"
import { getTransportReport, transportReportReset } from "store/actions"
const Pickup = ({ attendType }) => {
  const dispatch = useDispatch()
  const live_Url = "https://marcopolo.prisms.in"
  const acad_id = localStorage.getItem("acad_id")
  const { sid, staff_id } = useParams()
  const [busData, setBusData] = useState([])
  const [routeData, setRouteData] = useState([])
  const [route_id, setRouteId] = useState("")

  const [data, setData] = useState({
    bus_id: "",
    cday: moment().format("YYYY-MM-DD"),
  })

  useEffect(() => {
    const getTransportBus = async () => {
      try {
        const response = await axios.get(
          `${live_Url}/api/QR/attendance/bus/${sid}/${staff_id}`
        )
        setBusData(response.data.data)
      } catch (error) {
        // console.log(error)
      }
    }

    getTransportBus()
  }, [sid, staff_id])

  useEffect(() => {
    const getRouteBus = async () => {
      try {
        const response = await axios.post(
          `${live_Url}/api/QR/attendance/bus/route`,
          {
            sid: sid,
            bus_id: data.bus_id,
            acad_id: acad_id,
          }
        )
        setRouteData(response.data.data)
      } catch (error) {
        console.log(error)
      }
    }

    if (data.bus_id && acad_id) {
      getRouteBus()
    }
  }, [data.bus_id, acad_id])

  useEffect(() => {
    if (sid && data.bus_id && route_id && attendType && data.cday) {
      dispatch(
        getTransportReport({
          sid: sid,
          bus_id: data.bus_id,
          route_id: Number(route_id),
          date: data.cday,
          event: attendType,
        })
      )
    }
  }, [sid, data.bus_id, route_id, attendType, data.cday])

  useEffect(() => {
    return () => {
      dispatch(transportReportReset())
    }
  }, [])
  return (
    <Container className="py-3">
      <Row>
        <FormGroup>
          <Input
            type="select"
            onChange={e => {
              const selectedBus = busData.find(
                bus => bus.bus_id === Number(e.target.value)
              )
              if (selectedBus) {
                setData(prev => ({
                  ...prev,
                  bus_id: selectedBus.bus_id,
                  bus_name: selectedBus.bus_name,
                  bus_no: selectedBus.bus_no,
                }))
              }
            }}
          >
            <option value="">-- Select Bus --</option>

            {busData.map((bus, idx) => (
              <option key={idx} value={bus.bus_id}>
                {bus.bus_name}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Input type="select" onChange={e => setRouteId(e.target.value)}>
            <option value="">-- Select Route --</option>
            {routeData.map((route, idx) => (
              <option key={idx} value={route.route_id}>
                {route.routename}
              </option>
            ))}
          </Input>
        </FormGroup>

        <Absent attendType={attendType} />
      </Row>
    </Container>
  )
}

export default Pickup
